import {
  ABOUT_PAGE_FIELDS_FRAGMENT,
  CONTACT_PAGE_FIELDS_FRAGMENT,
  CONTENT_BLOCK_PAGE_FIELDS_FRAGMENT,
  EDITOR_BLOCKS_FRAGMENT,
  HOME_PAGE_FIELDS_FRAGMENT,
  MEDIA_ITEM_FIELDS_FRAGMENT,
  SCHEDULE_PAGE_FIELDS_FRAGMENT,
  WOOBOX_BLOCK_FRAGMENT,
} from './fragments';

export const GET_SITES_QUERY = /* GraphQL */ `
  query GetSites {
    sites {
      id
      name
      path
    }
  }
`;

export const GET_ALLSTAR_MENU_QUERY = /* GraphQL */ `
  query GetAllStarMenu {
    allStarCupMenuItems: menuItems(
      where: { location: ALLSTARCUP, parentId: 0 }
    ) {
      nodes {
        label
        uri
        childItems {
          nodes {
            label
            uri
          }
        }
      }
    }
  }
`;

export const GET_MENUS_QUERY = /* GraphQL */ `
  query GetMenus {
    headerMenuItems: menuItems(where: { location: PRIMARY, parentId: 0 }) {
      nodes {
        label
        uri
        childItems {
          nodes {
            label
            uri
          }
        }
      }
    }
    footerMenuItems: menuItems(where: { location: FOOTER, parentId: 0 }) {
      nodes {
        label
        uri
        childItems {
          nodes {
            label
            uri
          }
        }
      }
    }
    mobileMenuItems: menuItems(where: { location: MOBILE, parentId: 0 }) {
      nodes {
        label
        uri
      }
    }
  }
`;

export const GET_PAGE_QUERY = /* GraphQL */ `
  query GetPage(
    $id: ID!
    $idType: PageIdType!
    $includeHome: Boolean! = false
    $includeAbout: Boolean! = false
    $includeContact: Boolean! = false
    $includeBlocks: Boolean! = false
    $includeContentBlock: Boolean! = false
    $includeScheduleBlocks: Boolean! = false
    $asPreview: Boolean! = false
  ) {
    page(id: $id, idType: $idType, asPreview: $asPreview) {
      id: databaseId
      slug
      title
      ...HomePageFields @include(if: $includeHome)
      ...AboutPageFields @include(if: $includeAbout)
      ...ContactPageFields @include(if: $includeContact)
      ...EditorBlocks @include(if: $includeBlocks)
      ...ContentBlockPageFields @include(if: $includeContentBlock)
      ...SchedulePageFields @include(if: $includeScheduleBlocks)
      seo {
        title
        metaDesc
        canonical
        opengraphTitle
        opengraphDescription
        opengraphImage {
          sourceUrl
        }
      }
    }
  }
  ${MEDIA_ITEM_FIELDS_FRAGMENT}
  ${HOME_PAGE_FIELDS_FRAGMENT}
  ${ABOUT_PAGE_FIELDS_FRAGMENT}
  ${CONTACT_PAGE_FIELDS_FRAGMENT}
  ${EDITOR_BLOCKS_FRAGMENT}
  ${CONTENT_BLOCK_PAGE_FIELDS_FRAGMENT}
  ${SCHEDULE_PAGE_FIELDS_FRAGMENT}
`;

export const GET_PAGES_QUERY = /* GraphQL */ `
  query GetPages($first: Int! = 10, $after: String) {
    pages(first: $first, after: $after) {
      nodes {
        uri
        slug
        title
        parent {
          node {
            uri
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const GET_POST_QUERY = /* GraphQL */ `
  query GetPost($id: ID!, $idType: PostIdType!, $asPreview: Boolean = false) {
    post(id: $id, idType: $idType, asPreview: $asPreview) {
      id: databaseId
      slug
      title
      content
      date
      author {
        node {
          name
        }
      }
      featuredImage {
        node {
          ...MediaItemFields
        }
      }
      featuredImages {
        desktopImage {
          node {
            ...MediaItemFields
          }
        }
        mobileImage {
          node {
            ...MediaItemFields
          }
        }
      }
      editorBlocks {
        ...WooboxBlock
      }
      seo {
        title
        metaDesc
        canonical
        opengraphTitle
        opengraphDescription
        opengraphImage {
          sourceUrl
        }
        canonical
        metaRobotsNoindex
        metaRobotsNofollow
      }
    }
  }
  ${MEDIA_ITEM_FIELDS_FRAGMENT}
  ${WOOBOX_BLOCK_FRAGMENT}
`;

export const GET_POSTS_QUERY = /* GraphQL */ `
  query GetPosts($first: Int! = 10, $after: String) {
    posts(first: $first, after: $after) {
      nodes {
        id: databaseId
        slug
        title
        uri
        date
        excerpt
        isSticky
        author {
          node {
            name
          }
        }
        featuredImage {
          node {
            ...MediaItemFields
          }
        }
        featuredImages {
          mobileImage {
            node {
              ...MediaItemFields
            }
          }
          desktopImage {
            node {
              ...MediaItemFields
            }
          }
        }
        categories {
          nodes {
            name
          }
        }
        teamTaxonomies {
          nodes {
            name
          }
          edges {
            isPrimary
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${MEDIA_ITEM_FIELDS_FRAGMENT}
`;

export const GET_ALL_NETWORK_POSTS_QUERY = /* GraphQL */ `
  query GetAllNetworkPosts($first: Int! = 10) {
    allNetworkPosts(first: $first) {
      slug
      title
      uri
      site
    }
  }
`;

export const GET_POSTS_BY_CATEGORY_QUERY = /* GraphQL */ `
  query GetPostsByCategory(
    $first: Int! = 10
    $after: String
    $categories: [String]
  ) {
    posts(
      first: $first
      after: $after
      where: {
        taxQuery: {
          taxArray: {
            field: SLUG
            operator: IN
            taxonomy: TEAMTAXONOMY
            terms: $categories
          }
        }
      }
    ) {
      nodes {
        id: databaseId
        slug
        title
        uri
        date
        excerpt
        isSticky
        author {
          node {
            name
          }
        }
        featuredImage {
          node {
            ...MediaItemFields
          }
        }
        featuredImages {
          mobileImage {
            node {
              ...MediaItemFields
            }
          }
          desktopImage {
            node {
              ...MediaItemFields
            }
          }
        }
        categories {
          nodes {
            name
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${MEDIA_ITEM_FIELDS_FRAGMENT}
`;

export const GET_CATEGORIES_QUERY = /* GraphQL */ `
  query GetCategories {
    categories(first: 100) {
      nodes {
        name
      }
    }
  }
`;

export const GET_FORM_QUERY = /* GraphQL */ `
  query GetForm($formId: ID!) {
    gfForm(id: $formId, idType: DATABASE_ID) {
      id: databaseId
      title
      description
      formFields(first: 25) {
        nodes {
          id: databaseId
          type
          ... on TextField {
            label
            placeholder
            isRequired
          }
          ... on TextAreaField {
            label
            placeholder
            isRequired
          }
          ... on EmailField {
            label
            placeholder
            isRequired
          }
          ... on PhoneField {
            label
            placeholder
            isRequired
          }
          ... on AddressField {
            label
            isRequired
            addressType
          }
          ... on SelectField {
            label
            placeholder
            isRequired
            choices {
              isSelected
              text
              value
            }
          }
          ... on ConsentField {
            label
            isRequired
            checkboxLabel
          }
        }
      }
      submitButton {
        text
      }
      confirmations {
        message
      }
    }
  }
`;

export const GET_MODAL_CONTENT = /* GraphQL */ `
  query GetModalContent {
    acfSiteSettings {
      siteSettingsGroup {
        modalImage {
          node {
            sourceUrl
          }
        }
        modalLink {
          url
        }
      }
    }
  }
`;

export const GET_ARTICLE_BANNER_CONTENT = /* GraphQL */ `
  query GetArticleBannerContent {
    acfSiteSettings {
      siteSettingsGroup {
        articleTopBanner {
          bannerImage {
            node {
              sourceUrl
              altText
            }
          }
          mobileBannerImage {
            node {
              sourceUrl
              altText
            }
          }
          bannerLink {
            target
            title
            url
          }
        }
      }
    }
  }
`;

export const GET_HOMEPAGE_BANNER_CONTENT = /* GraphQL */ `
  query GetHomepageBannerContent {
    acfSiteSettings {
      siteSettingsGroup {
        homepageTopBanner {
          bannerImage {
            node {
              sourceUrl
              altText
            }
          }
          mobileBannerImage {
            node {
              sourceUrl
              altText
            }
          }
          bannerLink {
            target
            title
            url
          }
        }
      }
    }
  }
`;

export const GET_FAVICON = /* GraphQL */ `
  query GetFavicon {
    mediaItem(id: "favicon", idType: SLUG) {
      mediaItemUrl
      mediaDetails {
        height
        width
      }
    }
  }
`;

// TODO: Add player tag to query
export const GET_POSTS_BY_PLAYER_QUERY = /* GraphQL */ `
  query GetPostsByPlayer($search: String) {
    posts(where: { search: $search }, first: 1) {
      nodes {
        id: databaseId
        slug
        title
        uri
        date
        excerpt
        author {
          node {
            name
          }
        }
        featuredImage {
          node {
            ...MediaItemFields
          }
        }
        featuredImages {
          mobileImage {
            node {
              ...MediaItemFields
            }
          }
          desktopImage {
            node {
              ...MediaItemFields
            }
          }
        }
        categories {
          nodes {
            name
          }
        }
      }
    }
  }
  ${MEDIA_ITEM_FIELDS_FRAGMENT}
`;

export const GET_POSTS_BY_GAME_QUERY = /* GraphQL */ `
  query GetPostsByGame($gameTag: String!) {
    posts(
      where: {
        taxQuery: {
          taxArray: {
            field: SLUG
            operator: IN
            taxonomy: TAG
            terms: [$gameTag]
          }
        }
      }
      first: 10
    ) {
      nodes {
        id: databaseId
        slug
        title
        uri
        date
        excerpt
        author {
          node {
            name
          }
        }
        featuredImage {
          node {
            ...MediaItemFields
          }
        }
        featuredImages {
          mobileImage {
            node {
              ...MediaItemFields
            }
          }
          desktopImage {
            node {
              ...MediaItemFields
            }
          }
        }
        categories {
          nodes {
            name
          }
        }
        tags {
          nodes {
            name
            slug
          }
        }
      }
    }
  }
  ${MEDIA_ITEM_FIELDS_FRAGMENT}
`;

export const GET_VENUES_QUERY = /* GraphQL */ `
  query GetVenues($first: Int! = 10, $after: String) {
    venues(first: $first, after: $after) {
      nodes {
        uri
        slug
        title
        parent {
          node {
            uri
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const GET_VENUE_QUERY = /* GraphQL */ `
  query GetVenue($id: ID!, $idType: VenueIdType!, $asPreview: Boolean = false) {
    venue(id: $id, idType: $idType, asPreview: $asPreview) {
      id: databaseId
      slug
      title
      venueContent {
        hero {
          heading
          location
          text
          ctaButton {
            target
            title
            url
          }
          photo {
            node {
              ...MediaItemFields
            }
          }
        }
        localSponsor {
          label
          sponsorLogo {
            node {
              ...MediaItemFields
            }
          }
        }
        ticketPackages {
          disableSection
          heading
          ticketPackages {
            price
            text
            title
            purchaseLink {
              target
              title
              url
            }
          }
        }
        scheduleHeading
        postseasonScheduleHeading
        allStarScheduleHeading
        otherTicketPackages {
          disableSection
          heading
          ticketPackages {
            title
            text
            purchaseLink {
              target
              title
              url
            }
            photo {
              node {
                ...MediaItemFields
              }
            }
          }
        }
        faqs {
          disableSection
          heading
          items {
            content
            headline
          }
        }
        wooboxId
      }
    }
  }
  ${MEDIA_ITEM_FIELDS_FRAGMENT}
`;
